import { Link } from 'react-router';
import { DEFAULT_TZ, spendAmount, type LocalDate } from '@tahi/core';
import type { SpendingEntry } from '../../../data/repos/spending';
import { Money } from '../../../ui';
import { dayHeading, entryTime, sourceLabel, spokenPeso } from '../format';
import { FOCUS } from '../styles';

interface EntryRowProps {
  entry: SpendingEntry;
  categoryName: string | null;
  today: LocalDate;
}

export function EntryRow({ entry, categoryName, today }: EntryRowProps) {
  const signed = spendAmount(entry);
  const primary =
    entry.note ?? categoryName ?? entryTime(entry.createdAt, entry.recordedTz ?? DEFAULT_TZ);
  const label = `${spokenPeso(signed)}, ${primary}, ${dayHeading(entry.date, today)}`;
  return (
    <li>
      <Link
        to={`/m/spending/entries/${entry.id}`}
        aria-label={label}
        className={`flex min-h-11 items-center justify-between gap-3 rounded-xl px-2 py-2 ${FOCUS}`}
      >
        <span className="min-w-0">
          <span className="block truncate text-fg">{primary}</span>
          <span className="flex flex-wrap gap-1 text-xs">
            {entry.note && categoryName ? (
              <span className="rounded-full bg-secondary px-2 py-0.5 text-muted">
                {categoryName}
              </span>
            ) : null}
            {entry.sourceModule !== 'spending' ? (
              <span className="rounded-full border border-primary px-2 py-0.5 text-primary">
                {sourceLabel(entry.sourceModule)}
              </span>
            ) : null}
          </span>
        </span>
        <span className={`shrink-0 ${signed < 0 ? 'text-success' : 'text-fg'}`}>
          {signed < 0 ? '−' : ''}
          <Money minor={Math.abs(signed)} />
        </span>
      </Link>
    </li>
  );
}
